<template>
  <div style="background: mediumspringgreen">
    <h3>Controls</h3>
    <div>
      <button :disabled="cameraOrMicBlocked" @click="$store.dispatch('localVideo', !localParticipant.video)">
        {{ localParticipant.video ? "Turn camera off" : "Turn camera on" }}
      </button>
      <button :disabled="cameraOrMicBlocked" @click="$store.dispatch('localAudio', !localParticipant.audio)">
        {{ localParticipant.audio ? "Turn audio off" : "Turn audio on" }}
      </button>
      <button @click="$store.dispatch(localParticipant.screen ? 'stopScreenShare' : 'startScreenShare' )">
        {{ localParticipant.screen ? "Stop sharing screen" : "Start sharing screen" }}
      </button>
      <div>
        <button v-if="isMeetingOwner" @click="() => $store.dispatch('endMeeting', true)">End meeting</button>
        <button @click="endMeeting">Leave</button>
      </div>
      <div>
        <button @click="$store.dispatch('setRoomPublic', !isPublic)">
          {{ isPublic ? 'Set room private' : 'Set room public' }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Reactions from "@/components/Reactions";
import MobileExitPopUp from "@/components/MobileExitPopUp";

export default {
  name: "Controls",

  data() {
    return {
      timer: 0.01,
      interval: null,

      ops: {
        mode: "native",
        sizeStrategy: "percent",
        detectResize: true,

        bar: {
          opacity: 0,
        },

        rail: {
          opacity: 0,
        },
      },
    };
  },

  components: {
    MobileExitPopUp,
    Reactions,
  },

  computed: {
    isPublic() {
      return this.$store.state.meeting.meeting.isPublic
    },
    cameraOrMicBlocked() {
      return this.$store.state.meeting.cameraOrMicBlocked
    },
    localParticipant() {
      return this.$store.getters.localParticipant
    },
    waitingParticipants() {
      return []
    },
    participants() {
      return this.$store.state.meeting.participants
    },
    messages() {
      return this.$store.state.meeting.messages
    },
    hasEnded() {
      return this.$store.getters.hasEnded
    },
    meetingAccessDenied() {
      return this.$store.getters.meetingAccessDenied
    },
    awaitingAccess() {
      return this.$store.getters.awaitingAccess
    },
    isMeetingOwner() {
      return this.$store.state.meeting.isOwner
    },
    notStarted() {
      return this.$store.getters.notStarted
    },
    isEnteringLobby() {
      return this.$store.getters.isEnteringLobby
    },
    isInLobby() {
      return this.$store.getters.isInLobby
    },
    isJoiningMeeting() {
      return this.$store.getters.isJoiningMeeting
    },
    isJoinedMeeting() {
      return this.$store.getters.isJoinedMeeting
    },
    hasLeftMeeting() {
      return this.$store.getters.hasLeftMeeting
    },
    hasMeetingError() {
      return this.$store.getters.hasMeetingError
    }
  },

  mounted() {
    window.__controls__ = this
  },

  methods: {
    startRecording() {
      if (this.payedSubscription) {
        this.$store.dispatch("startRecording");
        this.startTimer();
      } else {
        this.$store.commit("showModal", "unlock_features");
      }
    },

    stopRecording() {
      this.$store.dispatch("stopRecording");
      this.timer = 0.01;
      clearTimeout(this.interval);
    },

    startTimer() {
      this.interval = setTimeout(() => {
        this.timer += 0.01;
        this.startTimer();
      }, 1000);
    },

    toggleCaptions() {
      if (this.payedSubscription) {
        this.$store.dispatch("setShowCaptions", !this.showCaptions);
      } else {
        this.$store.commit("showModal", "unlock_features");
      }
    },

    cameraOn() {
      this.$store.dispatch("cameraOn");
    },

    cameraOff() {
      this.$store.dispatch("cameraOff");
    },

    micOn() {
      this.$store.dispatch("micOn");
    },

    micOff() {
      this.$store.dispatch("micOff");
    },

    startScreenShare() {
      this.$store.dispatch("startScreenShare");
    },

    stopScreenShare() {
      this.$store.dispatch("stopScreenShare");
    },
    endMeeting() {
      this.$store.dispatch('leaveMeeting')
    },
    leave() {
      this.$store.dispatch("leave");
    },
  },
};
</script>

<style lang="scss" scoped>
.drop {
  @media all and (max-width: 767px) {
    bottom: 100%;
    left: 0;
    right: 0;
  }

  .color_btn {
    text-align: center;
    background-color: #fc5a12;
    color: #fff;
  }
}

.button_wrap {
  z-index: 2;

  button {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: opacity 180ms, background-color 180ms;

    img {
      height: 22px;
    }

    &:hover {
      background-color: #fc5a12;
      transition: opacity 180ms, background-color 180ms;

      @media all and (max-width: 767px) {
        background-color: #000;
      }
    }
  }

  p {
    max-width: 48px;
    display: block;
    text-align: center;
    margin-top: 16px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
  }

  & + .button_wrap {
    margin-left: 16px;
  }

  &.active {
    button {
      background-color: #fc5a12;
      transition: opacity 180ms, background-color 180ms;

      &:hover {
        opacity: 0.8;
        transition: opacity 180ms;
      }
    }
  }

  .reactions_wrap {
    opacity: 0;
    transition: opacity 180ms;
    pointer-events: none;
  }

  &:hover {
    .reactions_wrap,
    .options_drop {
      opacity: 1;
      transition: opacity 180ms;
      pointer-events: all;
    }

    .options_drop {
      display: block;
    }
  }
}

.hide_touch {
  display: block;

  @media all and (max-width: 1000px) {
    display: none;
  }
}

.show_touch {
  display: none;

  @media all and (max-width: 1000px) {
    display: block;
  }
}

.recording_area {
  position: absolute;
  left: 0;
  top: 0;
  height: 48px;
  padding: 12px;
  border-radius: 16px;
  background-color: #000;
  display: flex;
  align-items: center;

  @media all and (max-width: 767px) {
    position: relative;
    margin-right: 16px;
  }

  button {
    margin-right: 16px;
    display: flex;
    align-items: center;

    img {
      height: 22px;
    }
  }

  span {
    border-radius: 8px;
    padding: 4px 8px;
    background-color: #fffeff;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
}

.scroll_wrap {
  min-width: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1;

  @media all and (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.options_drop {
  z-index: 1;
  top: -142px;
  right: 0;
  width: 422px;

  button {
    height: auto;
  }

  @media all and (max-width: 767px) {
    width: 100%;
    top: -100px;
  }

  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 150px;
    height: 50px;
    right: 0;
    top: 85%;
  }
}
</style>
